import { SmartTable } from '../../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor($state, $uibModal,Alert) {
    this.$state=$state;
	this.$uibModal=$uibModal;
	this.Alert = Alert;
    }

    $onInit() {
        this.st = new SmartTable();
this.label=angular.copy(this.labelGroup);
//this.displayItems=this.companyUsers;
    }


	showRemoveModal() {
        this.$uibModal
            .open({
                component: 'companyUserLabelMembersRemove',
				backdrop: 'static',
                resolve: {
                    companyId: () => this.companyId,
                    userLabelId: () => this.label.id,
                    userIds: () => this.st.selectedIds,
                },
            }).result
            .then(() => {
                this.$state.go('.', {userLabelId:this.label.id}, {reload: '^'});
                const key = 'company.user-directories.saaspass-users.user-labels.users.removed';
                const variables = {labelName: this.label.labelName};
                this.Alert('success', key, variables);
            },(res)=>{}).catch(function(error) {});
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/user-labels/user-labels.controller.js